import script from "./ClientContactCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientContactCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__